import { Controller } from "@hotwired/stimulus"

const transliteration = {
  а: "a", б: "b", в: "v", г: "h", ґ: "g", д: "d", е: "e", є: "ye", ж: "zh", з: "z", и: "y", і: "i", ї: "yi", й: "y", к: "k", л: "l", м: "m", н: "n", о: "o", п: "p", р: "r", с: "s", т: "t", у: "u", ф: "f", х: "kh", ц: "ts", ч: "ch", ш: "sh", щ: "shch", ь: "", ю: "yu", я: "ya", э: "e", ы: "y", ё: "yo", ъ: ""
}

export default class extends Controller {
  static targets = ["source", "slug"]

  connect() {
    this.manual = false
  }

  sourceChanged() {
    if (!this.manual) this.slugTarget.value = this.slugify(this.sourceTarget.value)
  }

  slugChanged() {
    this.manual = true
  }

  slugify(value) {
    return value
      .toLocaleLowerCase()
      .split("")
      .map((character) => transliteration[character] || character)
      .join("")
      .normalize("NFKD")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }
}
